'use strict';

import allConditions from '../tables/conditions';

// Priority lists use the exact label string shown in each context:
// - pro side (medical_pro, fitness_pro): name field
// - consumer side (consumer, patient, client): consumer_name || name
const CONDITION_PRIORITIES = {
    consumer: [
        'General Healthy Diet',
        'Lose Weight',
        'Anti-Inflammatory',
        'High Fiber / High Protein',
    ],
    medical_pro: [
        'General Healthy Diet',
        'Mediterranean Diet',
        'Anti-Inflammatory',
        'High Fiber / High Protein',
        'Overweight/Obesity',
    ],
    patient: [
        'General Healthy Diet',
        'Mediterranean Diet',
        'Anti-Inflammatory',
        'High Fiber / High Protein',
        'Lose Weight',
    ],
    fitness_pro: [
        'General Healthy Diet',
        'Overweight/Obesity',
        'Muscle Gain',
        'Hypertension',
        'High Cholesterol',
        'Anti-Inflammatory',
        'High Fiber / High Protein',
    ],
    client: [
        'General Healthy Diet',
        'Lose Weight',
        'Muscle Gain',
        'High Blood Pressure',
        'High Cholesterol',
        'Anti-Inflammatory',
        'High Fiber / High Protein',
    ],
};

export function conditionSortCompare(a, b, context = 'consumer') {
    // Backward compat: old callers pass true/false
    if (context === true)  context = 'consumer';
    if (context === false) context = 'medical_pro';

    const useConsumerName = !['medical_pro', 'fitness_pro'].includes(context);
    const aName = useConsumerName ? (a.consumer_name || a.name) : a.name;
    const bName = useConsumerName ? (b.consumer_name || b.name) : b.name;

    const priorities = CONDITION_PRIORITIES[context] || [];
    const aIdx = priorities.indexOf(aName);
    const bIdx = priorities.indexOf(bName);

    if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
    if (aIdx !== -1) return -1;
    if (bIdx !== -1) return 1;

    return aName.localeCompare(bName);
}

export function getConditionContext(isPro, practiceType) {
    if (isPro) {
        return practiceType === 'fitness' ? 'fitness_pro' : 'medical_pro';
    }
    if (practiceType === 'fitness') return 'client';
    if (practiceType === 'dietetics') return 'patient';
    return 'consumer';
}

export function conditionNamesToConsumerName(conditions) {
    return conditions.map((name) => {
        const condition = allConditions.filter((c) => c.name === name)[0];

        return condition ? condition.consumer_name || condition.name : name;
    });
}

export function conditionNamesToSpecialName(conditions) {
    return conditions.map((name) => {
        const condition = allConditions.filter((c) => c.name === name)[0];

        return 'test';
        condition ? condition.special_name || condition.consumer_name || condition.name : name;
    });
}
